import React, {useEffect} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    useParams,
    useHistory, Link
} from "react-router-dom";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import postReducer, {fetchPostDetail, fetchPosts} from "../../api/redux/post";
import {useDispatch, useSelector} from "react-redux";
import {HelmetProvider, Helmet} from 'react-helmet-async'
import {Loading} from "../../components/Loading";
import InnerBanner from "../../components/InnerBanner";
import ProjectList from "../../components/project/ProjectList";
import {fetchEquipment} from "../../api/redux/equipment";
import {fetchProject} from "../../api/redux/project";
const MyComponent = () => {

    const dispatch = useDispatch()

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.PROJECT
        dispatch(fetchProject([api_url]))
    }, [])

    let getPost = useSelector(state => state.project)


    //Refactor data

    let meta=getPost?.posts?.page_data?.meta;
    let banner=getPost?.posts?.page_data?.banner;
    let projects=getPost?.posts?.projects;
    let newArray = projects?.map(item => item.type?.name);

    // Use Set to get unique values
    let uniqueTypes = [...new Set(newArray)];



    return (
        <HelmetProvider>
            {/*dynamic title */}
            <Helmet>
                <title>{`${meta?.meta_title ? meta?.meta_title : 'Projects | UCC Infrastructure Ltd.'}`}</title>
                <meta name="description"  content={meta?.meta_desc ? meta?.meta_desc :''}/>
                <meta property="og:title" content={`${meta?.og_title ? meta?.og_title : 'Projects | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:subtitle" content={`${meta?.og_title ? meta?.og_title : 'Projects | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:description" content={meta?.og_desc ? meta?.og_desc :''}/>
                <meta property="og:url" content={window?.location?.href}/>
                <meta property="og:image" content={banner?.image}/>
                <meta property="og:type" content={"website"}/>
            </Helmet>

            <StyledComponent>
                <InnerBanner img={banner?.image} mimg={banner?.mimage} title={banner?.subtitle} text={banner?.title}/>
                <ProjectList data={projects} types={uniqueTypes}/>

            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`

`;

export default MyComponent;
